export default __webpack_public_path__ + "static/media/facebook-messenger.9bf1c018.svg";